<template>
    <div style="width:100%;height:100%">
        <!-- 功能按钮 -->
        <buttonlist @help="help" @opentable="opentable" @add="add" @del="del" @search="search" @reflash="reflash" @exps="exp" @imp="imp" @save="save"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <div style="margin-top: 2px;white-space: nowrap">
                    <el-button type="primary" size="mini" @click="batchCheck(0)" :disabled="!btn.batchaudit">{{$t('getapi[1315]') }}</el-button>
                    <el-button type="primary" size="mini" @click="batchReverseAudit(0)" :disabled="!btn.batchreverseaudit">{{$t('getapi[1316]') }}</el-button>
                    <el-button type="primary" size="mini" @click="importCost" :disabled="!btn.importcost">{{$t('getapi[1317]') }}</el-button>
                    <el-button type="primary" size="mini" @click="setFirstVender" :disabled="!btn.setfirstvender">{{$t('getapi[8795]') }}</el-button>
                    <el-button type="primary" size="mini" @click="setUnFirstVender" :disabled="!btn.setunfirstvender">{{$t('getapi[8796]') }}</el-button>
                    <el-button type="primary" size="mini" @click="batchSearch">{{$t('getapi[8797]') }}</el-button>
                    <el-button type="primary" size="mini" @click="searchExp">{{$t('getapi[922]') }}</el-button>
                </div>
                 <wTable id="xpane-0" ref="singleTable" :data="datajson" :loading="loading"
                         queryData="SchQuotationViewInfo"
                         :filter_language="['batch_price_flag','check_flag','ce_flag','valid_flag','avl_flag','preferred_flag']"
                         :filter_thousandth="['supply_limit','shipment_cycle','moq','package_qty','qty_limit']"
                         :filter_thousandth_purprice="['unit_price','net_unit_price']"
                         :header="tableHeader"  :option="tableOption"  @handleSelectionChange="handleSelectionChange" @edits="edits" @rowdblclick="openEdit"  @lct="lct"></wTable>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="display: flex">
                    <el-button type="primary" size="mini" @click="OneCheck(0)" :disabled="!btn.audit">{{$t('getapi[941]') }}</el-button>
                    <el-button type="primary" size="mini" @click="recheck" :disabled="!btn.unaudit">{{$t('getapi[1334]') }}</el-button>
                    <el-button type="primary" size="mini" @click="removeLimit" :disabled="!btn.delqtylimit">{{$t('getapi[1335]') }}
                    </el-button>
                </div>
                <div style="width:640px;min-width:640px">
                    <table>
                        <tr>
                            <td style="width:80px;min-width:80px">{{ $t('getapi[1163]') }}</td>
                            <td style="width:120px;min-width:120px">
                                <!--<el-input v-model="dataDetail.part_code" type="text" size="mini"></el-input>-->
                                <routejump :urlNo="12" v-if="dataDetail.valid_flag != 1 && addoredit == 1">
                                <el-input
                                        v-model="dataDetail.part_code"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddBom"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.part_code" type="text" size="mini" :readonly="true" class="readO"
                                          v-if="dataDetail.valid_flag == 1 || addoredit != 1"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[113]') }}</td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="dataDetail.part_version" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px">{{ $t('getapi[1164]') }}</td>
                            <td style="width:180px;min-width:180px">
                                <el-input v-model="dataDetail.part_name" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1287]') }}</td>
                            <td>
                                <routejump :urlNo="26" v-if="dataDetail.valid_flag != 1 && addoredit == 1">
                                <el-input
                                        v-model="dataDetail.vender_code"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddVender"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.vender_code" type="text" size="mini" :readonly="true" class="readO"
                                          v-if="dataDetail.valid_flag == 1 || addoredit != 1"></el-input>
                            </td>
                            <td>{{ $t('getapi[1296]') }}</td>
                            <td>
                                <el-checkbox v-model="dataDetail.valid_flag" :true-label="1" :false-label="0"
                                             :disabled="true"></el-checkbox>
                            </td>
                            <td>{{ $t('getapi[1197]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.vender_name" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-tabs>
                    <el-tab-pane :label="$t('getapi[11]')" v-if="visBaseInfo">
                        <div style="width:600px;min-width:600px">
                            <table style="border-spacing: 5px" @dblclick.stop>
                                <tr>
                                    <td style="width:80px;min-width:80px">{{ $t('getapi[1339]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <el-date-picker v-model="dataDetail.effective_date" type="date" size="mini"
                                                        style="width:100%"
                                                        :readonly="dataDetail.valid_flag == 1" :class="{'readO':dataDetail.valid_flag == 1}"></el-date-picker>
                                    </td>
                                    <td style="width:10px"></td>
                                    <td style="width:5px"></td>
                                    <td style="width:60px;min-width:60px">{{ $t('getapi[1337]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <el-input v-model="dataDetail.qty_limit" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                                  class="alignment-right"
                                                  :readonly="dataDetail.valid_flag == 1"
                                                  :class="{'readO':dataDetail.valid_flag == 1}"></el-input>
                                    </td>
                                    <td style="width:80px;min-width:80px">{{ $t('getapi[1294]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <el-input v-model="dataDetail.moq" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" class="mcolor"
                                                  v-if="dataDetail.valid_flag != 1"></el-input>
                                        <el-input v-model="dataDetail.moq" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"
                                                  v-if="dataDetail.valid_flag == 1"></el-input>
                                    </td>
                                    <td style="width:5px"></td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1166]') }}</td>
                                    <td>
                                        <routejump :urlNo="1">
                                        <el-select v-model="dataDetail.pur_measurementunit"
                                                   size="mini" :disabled="dataDetail.valid_flag == 1">
                                            <el-option v-for="item in data_pur_measurementunit" :key="item.Code"
                                                       :label="item.Name" :value="item.Code"></el-option>
                                        </el-select>
                                        </routejump>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ $t('getapi[164]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.package_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                                  :readonly="dataDetail.valid_flag == 1" :class="{'readO':dataDetail.valid_flag == 1}"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[1345]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.supply_limit" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                                  :readonly="dataDetail.valid_flag == 1" :class="{'readO':dataDetail.valid_flag == 1}"></el-input>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1304]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.exchange_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                                  :readonly="dataDetail.valid_flag == 1" :class="{'readO':dataDetail.valid_flag == 1}"></el-input>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                       {{ $t('getapi[8047]') }}
                                    </td>
                                    <td> <el-checkbox v-model="dataDetail.ce_flag" :true-label="1" :false-label="0"
                                                     :disabled="true"></el-checkbox></td>
                                    <td>{{ $t('getapi[143]') }}</td>
                                    <td rowspan="2">
                                        <el-input type="textarea" :rows="2" v-model="dataDetail.remark" size="mini"
                                                  :readonly="dataDetail.valid_flag == 1" :class="{'readO':dataDetail.valid_flag == 1}"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1340]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.part_master_unit" type="text" size="mini"
                                                  :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ $t('getapi[8200]') }}</td>
                                    <td><el-input v-model="dataDetail.material_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1343]') }}</td>
                                    <td>
                                        <el-input
                                                v-model="dataDetail.net_unit_price"
                                                type="number"
                                                autocomplete="off" title=""
                                                @mousewheel.native.prevent
                                                size="mini"
                                                @change="getNetUnitPrice"
                                                :readonly="true" class="readO"
                                                v-if="dataDetail.valid_flag == 1 || dataDetail.booltax == 1 || dataDetail.vender_code == ''"
                                                v-decimal-limit="$store.state.digitsetting.pur_price_digit"
                                        ></el-input>
                                        <el-input
                                                v-model="dataDetail.net_unit_price"
                                                type="number"
                                                autocomplete="off" title=""
                                                @mousewheel.native.prevent
                                                size="mini"
                                                @change="getNetUnitPrice"
                                                class="mcolor"
                                                v-if="dataDetail.valid_flag != 1 && dataDetail.booltax == 0 && dataDetail.vender_code != ''"
                                                v-decimal-limit="$store.state.digitsetting.pur_price_digit"
                                        ></el-input>
                                    </td>
                                    <td>{{ dataDetail.currency_code }}</td>
                                    <td>
                                        <div style="margin: auto;color:red">*</div>
                                    </td>
                                    <td>{{ $t('getapi[1344]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[124]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.part_model" type="text" size="mini"
                                                  :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1293]') }}</td>
                                    <td>
                                        <el-input
                                                v-model="dataDetail.unit_price"
                                                type="number"
                                                autocomplete="off" title=""
                                                @mousewheel.native.prevent
                                                size="mini"
                                                @change="getNetPrice"
                                                :readonly="true" class="readO"
                                                v-if="dataDetail.valid_flag == 1 || dataDetail.booltax == 0 || dataDetail.vender_code == ''"
                                                v-decimal-limit="$store.state.digitsetting.pur_price_digit"
                                        ></el-input>
                                        <el-input
                                                v-model="dataDetail.unit_price"
                                                type="number"
                                                autocomplete="off" title=""
                                                @mousewheel.native.prevent
                                                size="mini"
                                                @change="getNetPrice"
                                                class="mcolor"
                                                v-if="dataDetail.valid_flag != 1 && dataDetail.booltax == 1 && dataDetail.vender_code != ''"
                                                v-decimal-limit="$store.state.digitsetting.pur_price_digit"
                                        ></el-input>
                                    </td>
                                    <td>{{ dataDetail.currency_code }}</td>
                                    <td>
                                        <div style="margin: auto;color:red">*</div>
                                    </td>
                                    <td>{{ $t('getapi[1342]') }}</td>
                                    <td>
                                        <el-checkbox v-model="dataDetail.booltax" :true-label="1" :false-label="0"
                                                     :disabled="true"></el-checkbox>
                                    </td>
                                    <td>{{ $t('getapi[125]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.part_spec" type="text" size="mini"
                                                  :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1309]') }}</td>
                                    <td>
                                        <el-checkbox v-model="dataDetail.preferred_flag" :true-label="1"
                                                     :false-label="0"
                                                     :disabled="dataDetail.valid_flag == 1"></el-checkbox>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>AVL</td>
                                    <td>
                                        <el-checkbox v-model="dataDetail.avl_flag" :true-label="1" :false-label="0"
                                                     :disabled="true" ></el-checkbox>
                                    </td>
                                    <td>{{ $t('getapi[137]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.item_code" type="text" size="mini"
                                                  :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[6013]') }}</td>
                                    <td colspan="7">
                                        <el-input v-model="dataDetail.taobao" type="text" size="mini"></el-input>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1346]')" v-if="visCheckInfo">
                        <div style="width:500px;min-width:500px">
                            <table>
                                <tr>
                                    <td style="width:80px;min-width:80px">{{ $t('getapi[1112]') }}</td>
                                    <td style="width:120px;min-width:120px">
                                        <routejump :urlNo="27">
                                        <el-select v-model="dataDetail.packaging_spec" size="mini"
                                                   :disabled="dataDetail.valid_flag == 1">
                                            <el-option v-for="item in data_packaging_spec" :key="item.Code"
                                                       :label="item.Name" :value="item.Code"></el-option>
                                        </el-select>
                                        </routejump>
                                    </td>
                                    <td></td>
                                    <td style="width:80px;min-width:80px">{{ $t('getapi[1348]') }}</td>
                                    <td style="width:220px;min-width:220px">
                                        <el-input v-model="dataDetail.invalid_mail" type="text" size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[8204]') }}({{ $t('getapi[217]') }})</td>
                                    <td>
                                        <!-- <el-input v-model="dataDetail.produce_leadtime" type="number" size="mini"
                                                  :disabled="true" v-if="dataDetail.valid_flag == 1"></el-input> -->
                                        <el-input v-model="dataDetail.produce_leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="dataDetail.valid_flag == 1" :class="[dataDetail.valid_flag == 1?'readO':'mcolor']"></el-input>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ $t('getapi[6016]') }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[8176]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.ship_days" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[8177]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.air_days" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1295]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.shipment_cycle" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1308]') }}</td>
                                    <td>
                                        <el-checkbox v-model="dataDetail.check_flag" :true-label="1" :false-label="0"
                                                     :disabled="dataDetail.valid_flag == 1"></el-checkbox>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1298]')">
                        <div>
                            <el-button type="primary" size="mini" @click="addBatchPrice"
                                       v-if="dataDetail.valid_flag != 1">{{$t('getapi[6708]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="batchDel" v-if="dataDetail.valid_flag != 1">{{
                                $t('getapi[4097]') }}
                            </el-button>
                        </div>
                        <el-table :data="dataDetailbatchpriceModel" :highlight-current-row="true"
                                  show-overflow-tooltip="true" @selection-change="handleSelectionChange" border stripe
                                  size="mini" style="width: 100%;">
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="batch_floor_limit" :label="$t('getapi[1351]')"
                                             width="100" align="right">
                                <template scope="scope" v-if="dataDetail.valid_flag != 1">
                                    <el-input size="mini" v-model="scope.row.batch_floor_limit"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="price" :label="$t('getapi[1292]')" width="100"
                                             align="right">
                                <template scope="scope" v-if="dataDetail.booltax == 1 && dataDetail.valid_flag != 1">
                                    <el-input size="mini" v-model="scope.row.price"
                                              @change="getBatchNetPrice(scope)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="net_price" :label="$t('getapi[1352]')"
                                             width="100" align="right">
                                <template scope="scope" v-if="dataDetail.booltax == 0 && dataDetail.valid_flag != 1">
                                    <el-input size="mini" v-model="scope.row.net_price"
                                              @change="getBatchNetUnitPrice(scope)"></el-input>
                                </template>
                            </el-table-column>
                            <!--<el-table-column show-overflow-tooltip :label="$t('basic.edit')" width="80" v-if="dataDetail.valid_flag != 1">
                                <template slot-scope="scope">
                                    <el-popconfirm
                                        :confirmButtonText="$t('getapi[937]')"
                                        :cancelButtonText="$t('getapi[6]')"
                                        icon="el-icon-info"
                                        iconColor="red"
                                        :title="$t('getapi[637]')"
                                        @onConfirm="delline(scope)"
                                    >
                                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                                    </el-popconfirm>
                                </template>
                            </el-table-column>-->
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <!-- 表格 -->
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="PageSize"
                        background
                        small
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 搜索弹框 -->
        <serce :isVisible="isVisible" queryData="SchQuotationViewInfo" ref="ser" @getser="serclick"></serce>
        <!-- 采购件弹框 -->
        <!--<popudata :isVisible="cgvisible" @getcg="getcg" ref="input"></popudata>-->
        <selector :isVisible="cgvisible" :isBatch=false :selectType="1" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPurPopuDataList'" @callback="getcg" ref="input"></selector>
        <!-- 供应商弹框 -->
        <!--<supplier :isVisible="vendervisible" @getsupplier="getsupplier" ref="supplierinput"></supplier>-->
        <selector :isVisible="vendervisible" :isBatch=false :selectType="1" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetSupplyPopuDataList'" @callback="getsupplier"
                  ref="supplierinput"></selector>

         <ctable :isVisible="false" :title="$t('getapi[88]')" queryData="SchQuotationViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="isVisibleSearch" width="25%">
            <div style="background: white;white-space: nowrap;">
                <el-button type="primary" size="mini" @click.native.prevent="addsearch">{{$t('getapi[6467]')}}</el-button>
                <el-button type="primary" size="mini" @click.native.prevent="delsearch">{{$t('getapi[7241]')}}</el-button>
            </div>
            <div style="display: flex">
                <vxe-table
                        :data="dataSearch"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="350"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        ref="search"
                        :auto-resize="true"
                >
                    <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="part_code" :title="$t('getapi[8222]')" width="200">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.part_code" size="mini"></el-input>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
            <span slot="footer">
				<el-button type="primary" @click="getSearchView"  size="mini">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: 'ppoverview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false,
                isShowEdit: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('ppoverview'),
                SelectIndex: 0,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                dataDetail: [], // 数据详情
                oldDataDetail: '',
                dataDetailbatchpriceModel: [], //批量价格
                data_pur_measurementunit: [], // 采购计量单位
                data_packaging_spec: [], // 获取包装方式
                cgvisible: false,
                vendervisible: false,
                addoredit: 1, // 1:新增2：编辑
                btn: {
                    //删除明细
                    del: false,
                    //审核
                    audit: false,
                    //反审核
                    unaudit: false,
                    ///解除阈值
                    delqtylimit: false,
                    batchaudit: false,
                    batchreverseaudit: false,
                    importcost: false,
                    setfirstvender: false,
                    setunfirstvender: false,
                },
                ids: '',//批量删除价格id合集
                id: '', // 用于获取数据详情
                selectData: [],
                tableHeader: [],
                ///基础信息 tab页是否显示
                visBaseInfo:false,
                 ///交货检验 tab页是否显示
                visCheckInfo:false,
                oldrow:'',
                iscontinuedblclick: true,
                timeId: null,
                //批量查询价格表单
                isVisibleSearch: false,
                dataSearch: [],
                scrollTop:0,

                priceDigit:this.$store.state.digitsetting.pur_price_digit,
                amountDigit:this.$store.state.digitsetting.pur_amount_digit,
            };
        },
        create() {
        },
        beforeMount() {
        },
        mounted() {
            let that = this;
            that.$nextTick(() => {
                addEventListener('paste', that.keyPaste);//创建键盘粘贴监听事件
            });
            that.colsort();
            that.$processdata.pushModelCache('ppoverview', that)
            that.data_pur_measurementunit = Array.methods.getAllUnits();
            that.data_packaging_spec = Array.methods.getAllPuckType();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd();
            that.authority();
        },
        beforeDestroy() {
            let that = this
            removeEventListener('paste', that.keyPaste);
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[88]"),this.$t("getapi[17]"));
            },
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('SchQuotationViewInfo',0,PFileds=>{
                that.tableHeader=PFileds;
            });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (that.$limits.authority('plv4', 10, 1) == 0) {
                    ///交货检验 tab页是否显示
                    that.visCheckInfo=false;
                }
                else{
                    that.visCheckInfo=true;
                }
                if (that.$limits.authority('plv4', 11, 1) == 0) {
                    ///基础信息 tab页是否显示
                    that.visBaseInfo=false;
                }
                else{
                    that.visBaseInfo=true;
                }

                that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
                //管理权限
                if (that.$limits.authority('plv2', 45, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 45, 1) == 2) {
                    if (that.$limits.authority('plv3', 45,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 45,1) == 1) {
                        //编辑级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.exclusively_id)) {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                    if (that.$limits.authority('plv3', 45, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.exclusively_id)) {
                            if (that.dataDetail.valid_flag) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                }
                else{
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    //一览权限
                    if (that.$limits.ReadOnlyRightsView('plv2', 44, 1, that.total)) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                }
                that.$refs.SetBtn.InputBtnRight('T05_Quotation');
                that.btnauthority();
            },
            btnauthority() {
                let that = this;

                if (!that.$limits.fnIsEmpty(that.dataDetail.exclusively_id)) {
                    that.btn.delqtylimit = false;
                    if (that.$limits.authority('plv3', 45, 1) == 1) {
                        //编辑级
                        that.btn.delqtylimit = true;
                    }
                    if (that.$limits.authority('plv3', 45, 1) == 1) {
                        //删除级
                        that.btn.delqtylimit = true;
                    }
                }
                if (that.dataDetail.valid_flag == false && !that.$limits.fnIsEmpty(that.dataDetail.exclusively_id)) {
                    that.btn.audit = true;
                    that.btn.unaudit = false;

                    if (that.$limits.authority('plv4', 8, 1) == 1) {
                        ///可用
                        that.btn.audit = true;
                        that.btn.delqtylimit = true;
                    } else {
                        that.btn.unaudit = false;
                        that.btn.audit = false;
                        that.btn.delqtylimit = false;
                    }
                }

                if (that.dataDetail.valid_flag) {
                    that.btn.audit = false;
                    that.btn.unaudit = true;
                    that.btn.del = false;
                    if (that.$limits.authority('plv4', 9, 1) == 1) {
                        ///可用
                        that.btn.unaudit = true;
                        that.btn.delqtylimit = true;
                    } else {
                        that.btn.unaudit = false;
                        that.btn.audit = false;
                        that.btn.delqtylimit = false;
                    }
                }
                else {
                    that.btn.del = true;
                }
                that.batchaudit = false
                that.batchreverseaudit = false
                that.importcost = false
                that.setfirstvender = false
                that.setunfirstvender = false
                if(that.selectData.length > 0){
                    if(that.selectData.length == 1){
                        that.btn.importcost = true
                    } else {
                        that.btn.importcost = false
                    }
                    if (that.$limits.authority('plv4', 67, 1) == 1) {
                        that.btn.batchaudit = true
                    }
                    if (that.$limits.authority('plv4', 68, 1) == 1) {
                        that.btn.batchreverseaudit = true
                    }
                    if (that.$limits.authority('plv4', 88, 1) == 1) {
                        that.btn.setfirstvender = true
                        that.btn.setunfirstvender = true
                    }
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            //查看图纸
            lct(val) {
                let that = this
                let item = {
                    //技术文档
                    label:  this.$t('getapi[6575]'),
                    name: 'docmanageview',
                    path: '/docmanageview',
                    url: '/docmanageview',
                    icon: 'video-play'
                };
                that.$store.commit('setSharedParams', {
                    part_code: val.row.part_code
                });
                this.$router.push({ path: '/docmanageview'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            /*keyup(ev, row) {
                let that = this;
                that.edits(row);
            },
            keydown(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.datajson[index - 1];
                    that.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.datajson[index + 1];
                    that.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let result = this.datajson.findIndex(item => item.EXCLUSIVELY_ID === val.EXCLUSIVELY_ID);
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },*/
            //表格背景
            tableRowClassName({row, rowIndex}) {
                if (row.enable_flag == '是') {
                    return 'warning-row';
                }
                if (row.version_status == '不可用') {
                    return 'dark-row';
                }
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.intidata();
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('ppoverview',val)
                this.intidata();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    if (item.query_Condition == '' || item.query_Condition.length > 0) {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    }
                });
                console.log(parm);
                that.$http.urlpost('/Sch/Quotation/DataList', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndex)
                    });
                });
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'SchQuotationViewInfo');
            },
            // 刷新
            reflash() {
                /*let that = this
                this.intidata();
                if (that.id != '') {
                    that.getDetail(that.id)
                }*/
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            this.intidata();
                            if (that.id != '') {
                                that.getDetail(that.id)
                            } else {
                                that.confirmAdd()
                            }
                        });
                } else {
                    this.intidata();
                    if (that.id != '') {
                        that.getDetail(that.id)
                    } else {
                        that.confirmAdd()
                    }
                }
            },
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.isShowEdit = true;
                that.addoredit = 1;
                that.id = ''
                that.dataDetail = {
                    exclusively_id: 0,
                    vender_code: '',
                    vender_name: '',
                    part_id: 0,
                    part_code: '',
                    part_name: '',
                    part_version: '',
                    relation_p_part_id: 0,
                    vender_part_code: '',
                    field: '',
                    venderpartcode: '',
                    unit_price: '',
                    old_unit_price: '',
                    net_unit_price: '',
                    preferred_flag: 0,
                    moq: 1,
                    old_moq: 0,
                    old_shipment_cycle: 0,
                    supply_limit: 0,
                    pur_measurementunit: '',
                    tax_rate: 0,
                    exchange_rate: 1,
                    shipment_cycle: 0,
                    packaging_spec: '',
                    effective_date: '',
                    remark: '',
                    valid_flag: 0,
                    check_flag: 1,
                    part_model: '',
                    part_spec: '',
                    item_code: '',
                    create_person: '',
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    qty_limit: '',
                    invalid_mail: '',
                    avl_flag: 0,
                    package_qty: 0,
                    taobao: '',
                    booltax: 0,
                    currency_code: '',
                    part_master_unit: '',
                    A59LowestPrice: 0,
                    material_price: 0,
                    produce_leadtime: 0,
                    ship_days: 0,
                    air_days: 0
                };
                that.dataDetailbatchpriceModel = [];
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                // that.setCurrent('');
                that.authority();
            },
            edits(row) {
                let that = this;
                if(that.id == row.exclusively_id){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.isShowEdit = true;
                                that.id = row.exclusively_id
                                that.getDetail(row.exclusively_id);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.isShowEdit = true;
                        that.id = row.exclusively_id
                        that.getDetail(row.exclusively_id);
                    }
                }, 100);
            },
            getDetail(id) {
                let that = this;
               if( that.$limits.authority('plv2', 45, 1) <1){
                    return;
               }
                that.addoredit = 2;
                let parm = {
                    Id: id
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Sch/Quotation/GetSchQuotationByID', parm, function (res) {
                    if(res.Success == 1){
                        that.dataDetail = res.DataContent.schqModel;
                        that.dataDetailbatchpriceModel = res.DataContent.batchpriceModel;
                        that.dataDetail.packaging_spec = that.dataDetail.packaging_spec == ''?'':parseInt(that.dataDetail.packaging_spec)
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority()
                    }
                    loadingInstance.close()
                });
            },
            // 保存详情
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = {
                    schqModel: that.dataDetail,
                    batchpriceModel: that.dataDetailbatchpriceModel
                };
                that.$http.urlpost('/Sch/Quotation/SchQSaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        let parm = res.UniqueNum;
                        that.id = res.UniqueNum
                        that.getDetail(parm);
                    }
                });
                that.$refs.SetBtn.SetOneBtnEnable('save', true);
            },
            // 导出
            exp() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Sch/Quotation/ListToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "SchQuotationViewInfo",
                    fromname: that.$t("getapi[88]"),
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            imp() {
                let item = {
                    //label: '采购价格表导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/7',
                    url: '/exp/7',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/7'});
                this.$store.commit('selectMenu', item);
            },
            //审核
            OneCheck(val){
                let that=this;
                if(that.dataDetail.ce_flag==1){
                    that.$confirm(that.$t('getapi[8048]'), that.$t('getapi[194]'), {//"CE物料已确认供应商"
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.check(val);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                }
                else{
                    that.check(val);
                }
            },
            // 审核
            check(val) {
                let that = this;
                let parm = {
                    exclusively_id: that.dataDetail.exclusively_id,
                    effective_date: that.dataDetail.effective_date,
                    vender_code: that.dataDetail.vender_code,
                    relation_p_part_id: that.dataDetail.relation_p_part_id,
                    tax_rate: that.dataDetail.tax_rate,
                    IsReplace: val,
                    part_code: that.dataDetail.part_code,
                    part_name: that.dataDetail.part_name,
                    part_version: that.dataDetail.part_version,
                    net_unit_price: that.dataDetail.net_unit_price,
                    A59LowestPrice: that.dataDetail.A59LowestPrice
                };
                that.$http.urlpost('/Sch/Quotation/ExecuteAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getDetail(that.id);
                    } else if(res.Success == 2){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.check(1)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    } else if(res.Success == 3){
                        that.getDetail(that.id);
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.$confirm('您确定审核此条价格信息么', that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.check(0)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            // 反审
            recheck() {
                let that = this;
                let parm = {
                    exclusively_id: that.dataDetail.exclusively_id,
                    valid_flag: that.dataDetail.valid_flag
                };
                that.$http.urlpost('/Sch/Quotation/ReverseAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.addoredit = 1
                        that.getDetail(that.id);
                    }
                });
            },
            // 解除阈值
            removeLimit() {
                let that = this;
                if (that.addoredit == 1) {
                    that.dataDetail.qty_limit = ''
                } else {
                    let parm = {
                        part_code: that.dataDetail.part_code,
                        part_version: that.dataDetail.part_version,
                        vender_code: that.dataDetail.vender_code
                    };
                    that.$http.urlpost('/Sch/Quotation/DelQtyLimit', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(Common.SuccessMsg);
                            that.getDetail(that.id);
                        }
                    });
                }
            },
            // 删除批量价格
            delline(row) {
                let that = this;
                let parm = {
                    exclusively_id: row.row.exclusively_id,
                    ids: ''
                };
                that.$http.urlpost('/Sch/Quotation/DeleteBatchPrice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getDetail(that.id);
                    }
                });
            },
            showAddBom() {
                let that = this;
                that.cgvisible = true;
                this.$refs.input.clearInput(that.cgvisible);
            },
            showAddVender() {
                let parm = {
                    part_code: this.dataDetail.part_code,
                    part_version: this.dataDetail.part_version,
                    exclusively_id: this.dataDetail.relation_p_part_id
                };
                this.vendervisible = true;
                this.$refs.supplierinput.clearInput(this.vendervisible, parm);
            },
            getsupplier(e) {
                console.log(e);
                this.dataDetail.vender_code = e.vender_code;
                this.dataDetail.tax_rate = e.tax_rate;
                this.dataDetail.booltax = e.tax_flag == true ? 1 : 0;
                this.dataDetail.vender_name = e.vender_name;
            },
            getcg(data) {
                console.log(data);
                let that = this;
                that.dataDetail.part_code = data.part_code;
                that.dataDetail.part_name = data.part_name;
                that.dataDetail.part_version = data.part_version;
                that.dataDetail.part_master_unit = data.part_master_unit;
                that.dataDetail.part_spec = data.part_spec;
                that.dataDetail.item_code = data.item_code;
                that.dataDetail.relation_p_part_id = data.exclusively_id;
                that.dataDetail.pur_measurementunit = data.pur_measurementunit;
                that.dataDetail.avl_flag = data.avl_flag;
                that.dataDetail.part_id = data.part_id;
            },
            addBatchPrice() {
                let that = this;
                that.dataDetailbatchpriceModel = [
                    ...that.dataDetailbatchpriceModel,
                    {
                        exclusively_id: 0,
                        vender_code: '',
                        p_part_id: 0,
                        batch_floor_limit: 0,
                        price: 0,
                        net_price: 0,
                        old_price: 0,
                        old_batch_floor_limit: 0
                    }
                ];
            },
            // 多选
            handleSelectionChange(val) {
                let that = this;
                that.ids = ''
                that.selectData = []
                for (let i = 0; i < val.length; i++) {
                    that.ids = that.ids + val[i].exclusively_id + ','
                    that.selectData.push(val[i])
                }
                that.ids = that.ids.substring(0, that.ids.length - 1)
                that.btnauthority()
            },
            //批量价格删除
            batchDel() {
                let that = this;
                let parm = {
                    exclusively_id: that.dataDetail.exclusively_id,
                    ids: that.ids
                };
                that.$http.urlpost('/Sch/Quotation/DeleteBatchPrice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getDetail(that.id);
                    }
                });
            },
            // 根据税率和含税单价获取不含税价格
            getNetPrice() {
                let that = this;
                that.dataDetail.unit_price = parseFloat(that.dataDetail.unit_price).toFixed(that.priceDigit);
                that.dataDetail.net_unit_price = (that.dataDetail.unit_price / (1 + that.dataDetail.tax_rate / 100)).toFixed(that.priceDigit);
            },
            getNetUnitPrice() {
                let that = this;
                that.dataDetail.net_unit_price = parseFloat(that.dataDetail.net_unit_price).toFixed(that.priceDigit);
                that.dataDetail.unit_price = (that.dataDetail.net_unit_price * (1 + that.dataDetail.tax_rate / 100)).toFixed(that.priceDigit);
            },
            getBatchNetPrice(data) {
                let that = this;
                that.dataDetailbatchpriceModel[data.$index].price = parseFloat(that.dataDetailbatchpriceModel[data.$index].price).toFixed(that.priceDigit);
                that.dataDetailbatchpriceModel[data.$index].net_price = (that.dataDetailbatchpriceModel[data.$index].price / (1 + that.dataDetail.tax_rate / 100)).toFixed(that.priceDigit);
            },
            getBatchNetUnitPrice(data) {
                let that = this;
                that.dataDetailbatchpriceModel[data.$index].net_price = parseFloat(that.dataDetailbatchpriceModel[data.$index].net_price).toFixed(that.priceDigit);
                that.dataDetailbatchpriceModel[data.$index].price = (that.dataDetailbatchpriceModel[data.$index].net_price * (1 + that.dataDetail.tax_rate / 100)).toFixed(that.priceDigit);
            },
            //采购计量单位默认与库存计量单位一致
            setPartMasterUnit() {
                let that = this
                that.dataDetail.part_master_unit = that.dataDetail.pur_measurementunit
            },
            // 删除单据
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            exclusively_id: that.dataDetail.exclusively_id,
                            part_code: that.dataDetail.part_code,
                            part_version: that.dataDetail.part_version,
                            vender_code: that.dataDetail.vender_code
                        }
                        that.$http.urlpost('/Sch/Quotation/DelSchQuotation', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(Common.SuccessMsg);
                                that.intidata()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 导入标准成本
            importCost(){
                let that = this
                let parm = {
                    valid_flag: that.selectData[0].valid_flag,
                    partid: that.selectData[0].partid,
                    net_unit_price: that.selectData[0].net_unit_price,
                    currency_code: that.selectData[0].currency_code
                }
                that.$http.urlpost('/Sch/Quotation/SchBatchImportCost', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    }
                });
            },
            // 设置首选供应商
            setFirstVender(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        exclusively_id: that.selectData[i].exclusively_id,
                        partid: that.selectData[i].partid,
                        part_code: that.selectData[i].part_code,
                        part_name: that.selectData[i].part_name,
                        part_version: that.selectData[i].part_version,
                        vender_code: that.selectData[i].vender_code
                    }]
                }
                let parm = {
                    LangType: that.$processdata.getLang(),
                    list: arr
                }
                that.$http.urlpost('/Sch/Quotation/SchBatchFirstVender', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    }
                });
            },
            // 取消设置首选供应商
            setUnFirstVender(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        exclusively_id: that.selectData[i].exclusively_id,
                        partid: that.selectData[i].partid,
                        part_code: that.selectData[i].part_code,
                        part_name: that.selectData[i].part_name,
                        part_version: that.selectData[i].part_version,
                        vender_code: that.selectData[i].vender_code
                    }]
                }
                let parm = {
                    list: arr
                }
                that.$http.urlpost('/Sch/Quotation/SchBatchUnFirstVender', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    }
                });
            },
            //批量审核
            batchCheck(val){
                let that=this;
                let isnotice=0;
                for(let i = 0;i<that.selectData.length;i++){
                    if(that.selectData[i].ce_flag=='是'){
                        isnotice=1;
                    }
                }
                if(isnotice==1){
                    that.$confirm(that.$t('getapi[8048]'), that.$t('getapi[194]'), {//"CE物料已确认供应商"
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.batchAudit(val);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                }
                else{
                    that.batchAudit(val);
                }
            },
            // 批量审核
            batchAudit(val){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        exclusively_id: that.selectData[i].exclusively_id,
                        effective_date: that.selectData[i].effective_date,
                        part_code: that.selectData[i].part_code,
                        part_name: that.selectData[i].part_name,
                        part_version: that.selectData[i].part_version,
                        vender_code: that.selectData[i].vender_code,
                        net_unit_price: that.selectData[i].net_unit_price
                    }]
                }
                let parm = {
                    iscontinue: val,
                    list: arr,
                }
                that.$http.urlpost('/Sch/Quotation/SchBatchAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    } else if(res.Success == 2){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.batchAudit(res.Success)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            // 批量反审核
            batchReverseAudit(val){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        exclusively_id: that.selectData[i].exclusively_id,
                        valid_flag: that.selectData[i].valid_flag
                    }]
                }
                let parm = {
                    iscontinue: val,
                    list: arr,
                }
                that.$http.urlpost('/Sch/Quotation/SchBatchReverseAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    } else if(res.Success == 2){
                        that.batchReverseAudit(res.Success)
                    }
                });
            },
            /*批量查询价格表单*/
            // 获取数据
            getSearchView() {
                let that = this;
                that.loading = true;
                this.isVisibleSearch = false;
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: {
                        list: that.dataSearch
                    }
                };
                that.$http.urlpost('/Sch/Quotation/BatchDataList', parm, function (res) {
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.isVisibleSearch = false;
                });
            },
            // 查询
            batchSearch() {
                let that = this
                that.dataSearch = []
                that.isVisibleSearch = true;
            },
            // 导出
            searchExp() {
                let that = this;
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: {
                        list: that.dataSearch
                    }
                };
                that.$http.urlpost('/Sch/Quotation/BatchListToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            //新增一行
            addsearch() {
                let that = this
                that.dataSearch = [...that.dataSearch,{
                    part_code: ''
                }]
            },
            delsearch() {
                let that = this;
                let selectRecords = this.$refs.search.getCheckboxRecords();
                for (let i = selectRecords.length - 1; i >= 0; i--) {
                    let line = this.$refs.search.getRowIndex(selectRecords[i]);
                    that.dataSearch.splice(line, 1);
                }
            },
            // 粘贴
            keyPaste(e) {
                let that = this;
                if (this.$route.name == this.$options.name) {
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.checks(data);
                        }
                    }
                }
            },
            checks(datap) {
                let that = this
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                for (let i = 0; i < arr.length - 1; i++) {
                    if (arr[i].split('\\t').length == 1) {
                        that.dataSearch = [...that.dataSearch, {
                            part_code: arr[i].split('\\t')[0],
                        }]
                    }
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 45,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            }
        }
    };
</script>

<style lang="scss" scoped>
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-textarea {
        display: block;
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }
</style>
